export enum OnsiteVariantEnum {
  DEFAULT = 'DEFAULT',
  TITLE = 'TITLE',
  IMAGE_TOP = 'IMAGE_TOP',
  IMAGE_RIGHT = 'IMAGE_RIGHT',
  IMAGE_LEFT = 'IMAGE_LEFT',
}
